import {Badge, Button, ButtonGroup, CardActions, CardHeader, Divider, Grid2} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import Card from "@mui/material/Card";
import {Link, useNavigate} from "react-router-dom";
import AuthContext from "../Services/AuthContext";
import {Add, Delete, Edit, Event} from "@mui/icons-material";
import Main from "../Layout/Main";
import AddChildren from "../Panel/Children/AddChildren";
import EditChildren from "../Panel/Children/EditChildren";

function Children() {
    const [user] = useContext(AuthContext);
    const [items, setItems] = useState([]);
    const [refresh, setRefresh] = useState(0);

    const [addChildren, setAddChildren] = useState(false);
    const [editChildren, setEditChildren] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (user.token === "") {
            navigate("/");
        }
    }, [user.token, navigate]);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/children`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setItems(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [user, refresh]);

    function _delete(id) {
        fetch(`/api/children/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(() => {
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }

    const cards = items.map((item) => <Grid2 item size={12} key={item.id}>
        <Card>
            <CardHeader title={`${item.name} ${item.surname}`} subheader={`${item.street}, ${item.postal_code} ${item.city}`}/>
            <Divider/>

            <CardActions sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
                <ButtonGroup>
                    <Badge badgeContent={item.active_camps} color={'info'}><Link
                        to={`/registrations/${item.id}`}><Button variant={'outlined'} color={'info'} startIcon={<Event />}>Wydarzenia</Button></Link></Badge>
                    <Button onClick={() => setEditChildren(item)} variant={'outlined'} color={'success'} startIcon={<Edit />}>Edytuj</Button>
                    <Button variant={'outlined'} color={'error'} startIcon={<Delete />} onDoubleClick={() => _delete(item.id)}>Usuń</Button>
                </ButtonGroup>
            </CardActions>
        </Card>
    </Grid2>);
    return (<Main title={'Moje Dzieci'} actions={<>
        <Button variant={'contained'} onClick={() => setAddChildren(true)} startIcon={<Add />}>Dodaj Dziecko</Button>
    </>}>
        <Grid2 container spacing={4} justifyContent={'space-between'} flexWrap={'wrap'} sx={{width: '95vw', maxWidth: '1200px'}}>
            {cards}
        </Grid2>
        <AddChildren isOpen={addChildren} dismiss={() => setAddChildren(false)} onSuccess={() => setRefresh(r => ++r)} />
        <EditChildren data={editChildren} dismiss={() => setEditChildren(false)} onSuccess={() => setRefresh(r => ++r)} />
    </Main>);
}

export default Children;